module.exports = __webpack_public_path__ + "img/register-completed-image.06e0aff4.svg";